import {Component, Input, OnInit} from '@angular/core';

declare var $: any;
declare var jQuery: any;

@Component({
    selector: 'counter-widget',
    templateUrl: './counter.component.html',
    styleUrls: ['./counter.component.scss']
})


export class CounterComponent implements OnInit {

    @Input() title:any = "";
    @Input() content:any = "";
    @Input() icon:any = "";
    @Input() titleLink:any = "";

    ngOnInit() {

    }
}
